const $ = require('jquery');
const mustache = require('mustache');
const bodyScrollLock = require('body-scroll-lock');
const Localizer = require('Localizer');
const storeHoursMessagingUtils = require('header.storeHoursMessagingUtils');
const utility = require('header.utility');
const LocalizationDrawer = require('localization-drawer');

const templates = {
  notLocalized:
    'To See Inventory <div class="MyStore__store">Choose A Store</div>',
  localizedWithoutStoreHours:
    'You\'re shopping <div class="MyStore__store">{{#store}}{{store}}{{/store}}</div>',
  localizedWithStoreHours: `
    You're shopping
    <div class="MyStore__store">{{store}}</div>
    <div class="MyStore__hours MyStore__hours--{{openClosedClass}}">
      <span class="MyStore__dot MyStore__dot--{{openClosedClass}}"></span>
      <span class="MyStore__hours--bold"
        >{{#storeStatusMessage}}{{storeStatusMessage}}{{/storeStatusMessage}}</span
      >
      {{storeHoursElaboration}}
    </div>
  `,
};

const drawerStateDefaults = {
  localizationDrawerVisible: false,
  localizedStoreId: '0121',
};
let drawerState;

function isLocalizationDrawerOpen() {
  return (
    typeof drawerState !== 'undefined' && drawerState.localizationDrawerVisible
  );
}

function createStoreTitle() {
  if (
    Localizer.status.isSelfLocalized() ||
    Localizer.status.isAutoLocalized()
  ) {
    const localizedStore = Localizer.getLocalizedStore();
    const { name: localizedStoreName, storeHours: localizedStoreHours } =
      localizedStore || {};

    if (!localizedStoreHours || Object.keys(localizedStoreHours).length === 0) {
      return mustache.render(templates.localizedWithoutStoreHours, {
        store: localizedStoreName,
      });
    } else {
      $('.MyStore__down-icon').addClass('MyStore__down-iconlocalized');

      return mustache.render(templates.localizedWithStoreHours, {
        store: localizedStoreName,
        ...storeHoursMessagingUtils.getPrimaryStoreHoursMessaging(
          localizedStoreHours,
        ),
      });
    }
  }

  return templates.notLocalized;
}

function renderStoreTitle() {
  const storeTitleHtml = createStoreTitle();

  // Desktop
  $('#myStore').find('.MyStore__label').html(storeTitleHtml);

  // Mobile
  $('#myStoreMobile')
    .find('.MyStore__button')
    .attr('href', buildMobileStorefinderUrl())
    .find('.MyStore__label')
    .html(storeTitleHtml)
    .find('.MyStore__store')
    .addClass('MyStore__store--inline');
}

function buildMobileStorefinderUrl() {
  let url = `//${utility.getHostname()}/l/`;

  const currentPage = window.location.href;
  if (currentPage.indexOf('/l/search/') === -1) {
    url = url + '?URL=' + currentPage;
  } else {
    url = currentPage;
  }

  return url;
}

function toggleLocalizationDrawerVisibility(event) {
  event.preventDefault();

  if (drawerState.localizationDrawerVisible) {
    closeLocalizationDrawer();
  } else {
    openLocalizationDrawer();
  }
}

function openLocalizationDrawer() {
  if (drawerState.localizationDrawerVisible) return;

  drawerState.localizationDrawerVisible = true;

  const localizationDrawer = new LocalizationDrawer.default({
    channel: utility.getChannelId() === '1' ? 'desktop' : 'mobile',
    hostName: utility.getHostname(),
    selectedStoreId: drawerState.localizedStoreId,
  });

  let mask = document.getElementById('localization-mask');

  if (!mask) {
    mask = document.createElement('div');
    mask.classList.add('localization__mask--fixed');
    mask.id = 'localization-mask';
    mask.addEventListener('click', closeLocalizationDrawer);
    document.body.appendChild(mask);
  }

  const drawer = document.getElementById('myStore-overlay');
  drawer && bodyScrollLock.disableBodyScroll(drawer);

  localizationDrawer.createDrawer();
}

function closeLocalizationDrawer() {
  if (!drawerState.localizationDrawerVisible) return;

  const mask = document.getElementById('localization-mask');
  const drawerContent = document.getElementById('myStore-overlayWrapper');
  const drawer = document.getElementById('myStore-overlay');

  if (
    mask &&
    drawerContent &&
    drawer &&
    drawerState.localizationDrawerVisible
  ) {
    drawerState.localizationDrawerVisible = false;
    document.body.removeChild(mask);
    drawerContent.innerHTML = '';
    drawer.classList.add('u--hide');
    bodyScrollLock.enableBodyScroll(drawer);
  }
}

function init() {
  drawerState = { ...drawerStateDefaults };

  Localizer.localize().then((localizationResponse) => {
    const { storeId = '0121' } = localizationResponse.getLocalizedStore() || {};
    drawerState.localizedStoreId = storeId;
    /**
     * .ready() has been deprecated in later versions of
     * jQuery—which is what Nucleus uses.
     *
     * @todo: Even though this works, we might want to consider moving away from it.
     */
    $(document).ready(() => {
      renderStoreTitle();
    });
  });

  /**
   * `thd-localizer` does not itself contain any logic to refresh
   * the page on successful (re–)localization. It leaves that behavior
   * up to the consumer.
   *
   * If it did refresh the page itself, we wouldn't need this event listener,
   * because we set the store title on page load / refresh anyway. However,
   * since we can't rely on every re-localization refreshing the page,
   * we need to include this event to make sure the store title updates
   * within a given page load.
   */
  Localizer.on(Localizer.event.LOCALIZED, () => {
    $(document).trigger({ type: 'newStoreSet' });
  });

  $(document).on('newStoreSet', renderStoreTitle);
  $(document).on('searchState closeDrawer', closeLocalizationDrawer);
  $(document).on('launchLocDrawer', toggleLocalizationDrawerVisibility);
  $('#myStore, #myStoreMobile').on(
    'click touchend',
    toggleLocalizationDrawerVisibility,
  );

  $('#simpleMenuButton, #headerMyAccount').on(
    'click touchend',
    closeLocalizationDrawer,
  );
}

module.exports = { init, renderStoreTitle, isLocalizationDrawerOpen };
